export const APP_ENV = {
  dev: process.env.APP_ENV === 'development' || process.env.APP_ENV === 'dev',
  stage: process.env.APP_ENV === 'staging' || process.env.APP_ENV === 'stage',
  prod: process.env.APP_ENV === 'production' || process.env.APP_ENV === 'prod',
  test: process.env.NODE_ENV === 'test',
};
